import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _find from "lodash/find";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n            padding-left: ", ";\n          "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/** @jsx jsx */
import './index.scss';
import { css, jsx } from '@emotion/react';
import cx from 'classnames';
import { useCallback, useEffect, useRef, useState } from 'react';
import ReactResizeDetector from 'react-resize-detector';
import AiAssistantBody from './AiAssistant/Body';
import Body from './Body';
import HintAndSolution from './HintAndSolution';
import Tabs from './Tabs';
import { calculateMaxTabs, FeedbackMessage, FeedbackMessageType, getVisibleFeedbackMessages } from './utils';

var Feedbacks = function Feedbacks(_ref) {
  var Renderer = _ref.Renderer,
      extraClass = _ref.extraClass,
      feedbackMessages = _ref.feedbackMessages,
      hintAndSolution = _ref.hintAndSolution,
      innerRef = _ref.innerRef,
      isUserEnabledForAISubmissionHint = _ref.isUserEnabledForAISubmissionHint,
      onClickTab = _ref.onClickTab;
  var tabListRef = useRef(null);

  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      maxTabs = _useState2[0],
      setMaxTabs = _useState2[1];

  var predictions = useRef({});
  var setPrediction = useCallback(function (newPrediction, uuid) {
    predictions.current[uuid] = newPrediction;
  }, [predictions]);
  var setPredictionRated = useCallback(function (uuid) {
    var lastMessage = predictions.current[uuid];

    if (lastMessage) {
      lastMessage.rated = true;
    }
  }, [predictions]);
  var setMaxTabForRef = useCallback(function () {
    if (tabListRef.current) {
      setMaxTabs(calculateMaxTabs(tabListRef.current.offsetWidth, hintAndSolution.isVisible));
    }
  }, [hintAndSolution.isVisible]);
  useEffect(function () {
    return setMaxTabForRef();
  }, [setMaxTabForRef]);
  var visibleFeedbackMessages = getVisibleFeedbackMessages(feedbackMessages, maxTabs);

  var activeFeedbackMessage = _find(feedbackMessages, 'isActive');

  var isTabsDisplayed = visibleFeedbackMessages.length > 0;
  var isAiAssistant = activeFeedbackMessage != null && activeFeedbackMessage.aiAssistantProps != null;
  return jsx("section", {
    className: cx('dc-sct-feedback', extraClass),
    ref: innerRef,
    tabIndex: -1
  }, jsx(ReactResizeDetector, {
    handleHeight: true,
    handleWidth: true,
    onResize: function onResize() {
      return setMaxTabForRef();
    }
  }), jsx("nav", {
    className: "dc-sct-feedback__nav",
    ref: tabListRef
  }, isTabsDisplayed && jsx(Tabs, {
    feedbackMessages: visibleFeedbackMessages,
    onClickTab: onClickTab
  }), jsx("div", {
    css: css(_templateObject(), isTabsDisplayed ? '0' : '16px')
  }, jsx(HintAndSolution, {
    borderless: feedbackMessages.length !== 0,
    isSolution: hintAndSolution.isSolution,
    isVisible: hintAndSolution.isVisible,
    onClick: hintAndSolution.onClick,
    xp: hintAndSolution.xp
  }))), activeFeedbackMessage != null && (isAiAssistant && Renderer ? jsx(AiAssistantBody, _extends({
    Renderer: Renderer,
    body: activeFeedbackMessage.body || '',
    isSolutionShown: hintAndSolution.isSolutionShown,
    isUserEnabledForAISubmissionHint: isUserEnabledForAISubmissionHint,
    onClickShowSolution: hintAndSolution.onClick,
    predictions: predictions,
    sctRating: activeFeedbackMessage.rating,
    setPrediction: setPrediction,
    setPredictionRated: setPredictionRated,
    uuid: activeFeedbackMessage.key || ''
  }, activeFeedbackMessage)) : jsx(Body, activeFeedbackMessage)));
};

export default Feedbacks;